// src/pages/restaurant/EditMenu.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../../utils/api";
import SimpleMenuFormEditStaff from "../MenuForms/SimpleMenuFormEditStaff";
import AdvancedMenuFormEditStaff from "../MenuForms/AdvancedMenuEditFormStaff";

const StaffEditMenu = () => {
  const [searchParams] = useSearchParams();
  const menuId = searchParams.get("id");

  const [inventory, setInventory] = useState([]);
  const [menuData, setMenuData] = useState(null); // This holds fetched menu details
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("simple");

  // Fetch inventory
  useEffect(() => {
    api
      .get("restaurant-staff/inventory/get")
      .then((res) => {
        setInventory(res.data?.inventory || []);
      })
      .catch(console.error);
  }, []);

  // Fetch menu data by ID
  useEffect(() => {
    if (!menuId) return;

    setLoading(true);
    api
      .get(`restaurant-staff/restaurant/menu/all?menuId=${menuId}`)
      .then((res) => {
        setMenuData(res.data || null);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [menuId]);

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-6">Edit Menu</h2>

      {/* Tabs */}
      <div className="flex space-x-4 mb-6 border-b">
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "simple"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("simple")}
        >
          Simple
        </button>
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "advanced"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("advanced")}
        >
          Advanced
        </button>
      </div>

      {/* Content */}
      {selectedTab === "simple" ? (
        <SimpleMenuFormEditStaff inventory={inventory} menuData={menuData} />
      ) : (
        <AdvancedMenuFormEditStaff inventory={inventory} menuData={menuData} />
      )}
    </div>
  );
};

export default StaffEditMenu;
